var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUploadedHc = function SvgFileUploadedHc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 46,
    fill: "none",
    viewBox: "0 0 38 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#FFC300",
    d: "M36 45.5H2A1.5 1.5 0 0 1 .5 44V2A1.5 1.5 0 0 1 2 .5h23.793L37.5 12.207V44a1.5 1.5 0 0 1-1.5 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#FFC300",
    d: "M26.5 10V1.207L36.793 11.5H28a1.5 1.5 0 0 1-1.5-1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFC300",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m10 26.5 6 6.5 12-13"
  })));
};
export default SvgFileUploadedHc;